export default __webpack_public_path__ + "static/media/NIAS0230.34I-32830_-25733_0.629846b8.jpg";